const Document = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0007 1.6665H5.62565C4.36 1.6665 3.33398 2.69252 3.33398 3.95817V16.0415C3.33398 17.3072 4.36 18.3332 5.62565 18.3332H14.3757C15.6413 18.3332 16.6673 17.3072 16.6673 16.0415V8.33317H12.2923C11.0267 8.33317 10.0007 7.30716 10.0007 6.0415V1.6665Z"
      fill="#D0D0D4"
    />
    <path
      d="M16.2978 7.08317C16.2792 7.06234 16.26 7.04199 16.2402 7.02215L11.3117 2.09364C11.2918 2.0738 11.2715 2.0546 11.2507 2.03603V6.0415C11.2507 6.6168 11.717 7.08317 12.2923 7.08317H16.2978Z"
      fill="#D0D0D4"
    />
  </svg>
)

export default Document
